import { SvgIcon, type SvgIconProps } from './svgIcon'

export const CrossIcon = ({
  width = 48,
  height = 48,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    {...props}>
    <rect width={width} height={height} rx="24" fill="#121212" />
    <path
      d="M33 33L15 15M33 15L15 33"
      stroke="#FFFFFF"
      strokeWidth="4"
      strokeMiterlimit="10"
    />
  </SvgIcon>
)
